import { getIconColor } from "@lib/utils"
import clsx from "clsx"
import React from "react"

const ArrowUpRightIcon = ({ className, color }) => {
  const stroke = getIconColor(color)

  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("arrow-up-right-icon", className)}
    >
      <path
        d="M2.25 9.75L9.75 2.25M9.75 2.25L4.125 2.25M9.75 2.25V7.875"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowUpRightIcon
